import React, { useState } from "react";
import styles from "./Footer.module.scss";
import { Modal, Row, Col, Button, notification } from "antd";
import {
  CustomerCareDetails,
  DefaultCustomerCareDetails,
} from "../../types/PersonTypes";
import { getWandaCustomerCareDetails } from "../../services";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useWindowSize } from "../../hooks/useWindowSize";

type Props = {
  isAuth: boolean;
};

export default function Footer(props: Props) {
  const { isAuth } = props;
  const { executeRecaptcha } = useGoogleReCaptcha();
  const faqUrl: string = "https://wanda.care/faq/";
  const termsConditionsUrl: string = "https://wanda.care/terms-of-use/";
  const privacyPolicyUrl: string = "https://wanda.care/terms/privacy-policy/";
  const termsSaleUrl: string = "https://wanda.care/terms/termsofsale/";
  const bulletPoint = "\u2022"; // Unicode character for bullet point

  const [isContactUsModalVisible, setIsContactUsModalVisible] = useState<
    boolean
  >(false);
  const [customerCareDetails, setCustomerCareDetails] = useState<
    CustomerCareDetails
  >(DefaultCustomerCareDetails);
  const { width } = useWindowSize();

  const handleContactUsInfo = async () => {
    if (Object.values(customerCareDetails).some((value) => value === "")) {
      try {
        let recaptchaToken: string = "";
        if (executeRecaptcha && !isAuth) {
          const token = await executeRecaptcha();
          recaptchaToken = token;
        }
        const details = await getWandaCustomerCareDetails(recaptchaToken);
        setCustomerCareDetails(details);
        setIsContactUsModalVisible(true);
      } catch (error) {
        notification.error({
          message: "Error",
          description:
            "Failed to fetch Customer care details. Please try again later.",
        });
      }
    } else {
      setIsContactUsModalVisible(true);
    }
  };

  return (
    <>
      <div
        className={`${styles.footerContainer} ${
          width < 992 ? styles.footerContainerHeight : ""
        }`}
      >
        <p className={styles.footerText}>
          Wanda {bulletPoint} © {new Date().getFullYear()} All Rights Reserved{" "}
          <span className={styles.spanStyle}>
            {width > 992 && bulletPoint}{" "}
            <Button
              type="primary"
              id={styles.buttonLink}
              onClick={() => handleContactUsInfo()}
            >
              Contact Us
            </Button>{" "}
            {bulletPoint}{" "}
            <a href={faqUrl} target="_blank" rel="noopener noreferrer">
              FAQ
            </a>{" "}
            {bulletPoint}{" "}
            <a
              href={privacyPolicyUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>{" "}
          </span>
          {width > 992 && bulletPoint}{" "}
          <a
            href={termsConditionsUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Use
          </a>{" "}
          {bulletPoint}{" "}
          <a href={termsSaleUrl} target="_blank" rel="noopener noreferrer">
            Terms of Sale
          </a>
        </p>
      </div>
      <Modal
        className={styles.contactUsModalContainer}
        visible={isContactUsModalVisible}
        centered={true}
        width="unset"
        footer={
          <Row justify="center">
            <Col>
              <Button
                id={styles.modalCloseBtn}
                onClick={() => setIsContactUsModalVisible(false)}
              >
                Close
              </Button>
            </Col>
          </Row>
        }
      >
        <Row>
          <Col span={24} className={styles.contactUsModalTitle}>
            Contact Us
          </Col>
          <Col span={24} className={styles.contactUsModalSideHeading}>
            Email Address
          </Col>
          <Col span={24} className={styles.contactUsModalDescription}>
            {customerCareDetails.wandaCustomerCareMailAddress}
          </Col>
          <Col
            span={24}
            className={`${styles.contactUsModalSideHeading} ${styles.contactUsModalLineBreak}`}
          >
            Phone Number
          </Col>
          <Col span={24} className={styles.contactUsModalDescription}>
            {customerCareDetails.wandaCustomerCareNumber}
          </Col>
          <Col
            span={24}
            className={`${styles.contactUsModalTimings} ${"subTextFont"}`}
          >
            {customerCareDetails.wandaCustomerCareTimings}
          </Col>
        </Row>
      </Modal>
    </>
  );
}
